import * as React from "react";
import { SVGProps } from "react";
export const FloorPlanIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M15.1154 3H4.88462C3.85077 3 3 3.85077 3 4.88462V15.1154C3 16.1492 3.85077 17 4.88462 17H7.84615C8.28769 17 8.65385 16.6338 8.65385 16.1923V12.8108C10.9154 13.4462 12.4877 16.5262 12.5092 16.5585C12.6492 16.8277 12.9292 17 13.2308 17H15.1154C16.1492 17 17 16.1492 17 15.1154V4.88462C17 3.85077 16.1492 3 15.1154 3ZM15.3846 4.88462V7.98615H12.2831V4.61538H15.1046C15.2554 4.61538 15.3738 4.73385 15.3738 4.88462H15.3846ZM15.1154 15.3846H13.7046C13.0046 14.2 10.8938 11.0769 7.84615 11.0769C7.40462 11.0769 7.03846 11.4431 7.03846 11.8846V15.3846H4.88462C4.73385 15.3846 4.61538 15.2662 4.61538 15.1154V4.88462C4.61538 4.73385 4.73385 4.61538 4.88462 4.61538H10.6785V8.79385C10.6785 9.23538 11.0446 9.60154 11.4862 9.60154H15.3846V15.1154C15.3846 15.2662 15.2662 15.3846 15.1154 15.3846Z"
            fill="currentColor"
        />
    </svg>
);
FloorPlanIcon.displayName = "FloorPlanIcon";
